interface IProps {
  proposedTo: any
  createdBy: any
  logo?: string
  documentProjectID: number
  variant: string
  documentDate: string
  title: string
  logoSize?: 'sm' | 'md' | 'lg'
}
export default function CoverPageModel3({
  title,
  documentDate,
  proposedTo,
  createdBy,
  logo,
  logoSize,
  documentProjectID,
  variant,
}: IProps) {
  return (
    <div className="flex h-full">
      <div className="h-full w-[72px] min-w-[40px] bg-[#4A9AA7] rounded-lg mr-5" />

      <div className="flex flex-col justify-between w-full h-full">
        {/* Prepared By Info */}
        <div className="flex gap-10 text-xs">
          <div className="flex">Prepared by:</div>
          <div className="flex flex-col">
            {createdBy
              ?.split('\n')
              .slice(0, 3)
              .map((line, i) => (
                <div className="font-medium" key={i}>
                  {line}
                </div>
              ))}
          </div>
          <div className="flex flex-col">
            {createdBy
              ?.split('\n')
              .slice(3, 6)
              .map((line, i) => (
                <div key={i}>{line}</div>
              ))}
          </div>
        </div>

        {/* Main Title Section */}
        <div className="flex flex-col text-left w-full">
          {logo ? (
            <img src={logo} width={logoSize === 'lg' ? 420 : logoSize === 'md' ? 280 : 140} />
          ) : (
            <div>{createdBy?.split('\n')[0]}</div>
          )}
          <div className="text-5xl font-extrabold uppercase">{variant.toUpperCase()}</div>
          {documentProjectID && <div className="text-sm mt-3 font-medium">PROJECT ID: {documentProjectID}</div>}
          <div className="text-lg font-semibold leading-tight max-w-[600px] mt-1">{title}</div>
        </div>

        {/* Footer Section */}
        <div className="flex flex-col text-black p-6 rounded-lg text-xs">
          <div className="flex gap-10 w-full">
            <div className="flex gap-2">
              <div className="font-light">Prepared for:</div>
              <div className="flex flex-col">
                <div className="font-bold">{proposedTo?.split('\n')[0]}</div>
                <div>{proposedTo?.split('\n')[1]}</div>
                <div className="italic">{proposedTo?.split('\n')[2]}</div>
                <div className="mt-2">{proposedTo?.split('\n')[3]}</div>
                <div>{proposedTo?.split('\n')[4]}</div>
                <div>{proposedTo?.split('\n')[5]}</div>
              </div>
            </div>
            <div className="flex flex-col">
              <div className="font-light">Proposal Issued:</div>
              <div className="font-medium">{documentDate}</div>
            </div>
          </div>
          <div className="text-[10px] text-black mt-4 opacity-80">
            Confidentiality notice: This document and the accompanying materials contain confidential and proprietary
            business information. They may be printed or copied solely for the purpose of evaluating the project and
            must not be disclosed to any third party without prior written consent.
          </div>
        </div>
      </div>
    </div>
  )
}
